const demo = {
  // namespaced: true,
  state: {
    demo: 'name',
  },
};

export default demo;
